// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { Resource } from "./resource.js";
export class ComputePass extends Resource {
    static defaultProps = {
        ...Resource.defaultProps,
        timestampQuerySet: undefined,
        beginTimestampIndex: undefined,
        endTimestampIndex: undefined
    };
    get [Symbol.toStringTag]() {
        return 'ComputePass';
    }
    constructor(device, props) {
        super(device, props, ComputePass.defaultProps);
    }
}
//# sourceMappingURL=compute-pass.js.map